export default {
	// Banners are not modal, must be dismissed by the user
	BANNER: 'banner',
	// Dialogs are modal (sit in front of everything), must be dismissed by the user
	DIALOG: 'dialog',
	// Snackbars are not modal, can be dismissed by the user, automatically close after a short duration
	SNACKBAR: 'snackbar',
}